var I = /* @__PURE__ */ ((s) => (s.EDIT = "edit", s.VIEW = "view", s))(I || {}), e = /* @__PURE__ */ ((s) => (s.EMAIL = "email", s.PHONE = "phone", s))(e || {}), i = /* @__PURE__ */ ((s) => (s.PROVINCE = "provinces", s.STATE = "states", s.DISTRICT = "districts", s.SUBDISTRICT = "subdistricts", s.POSTALCODE = "postalcodes", s))(i || {});
export {
  i as C,
  I,
  e as v
};
//# sourceMappingURL=profileInformationEnums-e12b5b99.mjs.map
